/*
  ST 2026-10-08 (Wrike 4580724577): coupon "Oktober-Fit Days" on the PDP (snippets/st-coupon-box.liquid).
  1. Variant change: swap #CouponBox-<section>-<product> from the re-rendered section HTML (same pattern as
     assets/st-weekly-deal.js); the sticky bar line sits in #StickyPrice-…, which theme.js swaps itself.
  2. Countdowns [data-st-coupon-countdown] (box: "06 T · 22 Std · 31 Min"; data-pad="false" -> "6 T 22 Std")
     refresh every second from data-end (unix seconds) and data-format ([d] [h] [m]). They count to the variant's
     own coupon end; the top bar on the PDP counts to the same end (Ali 14.10.); "Bis …" [data-st-coupon-until]
     follows.
  3. At the end, [data-st-coupon-end] elements hide (box and the sticky bar chip "FIT DAYS"); no "0 T 0 Std", no
     "ended" text. The sticky bar strip "Deal endet in …" is ticked by theme.js (ProductStickyForm.startDealStrip).
  4. "Kopieren": copies the code (Clipboard API, fallback execCommand), shows "Kopiert ✓" for 2 s.
  Loaded by sections/main-product.liquid only when a variant has an active coupon.
*/
(function () {
  if (window.__stCouponBound) return;
  window.__stCouponBound = true;

  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }

  // Ali 14.10. 15:21 (Wrike 4582273667): box and sticky line count to the deadline of the variant's own coupon
  // (data-end, custom.coupon_end), no generic campaign end. data-end is rewritten below, so the first value is kept.
  function shownEnd(el) {
    if (!el.hasAttribute("data-variant-end"))
      el.setAttribute("data-variant-end", el.getAttribute("data-end"));
    return parseInt(el.getAttribute("data-variant-end"), 10);
  }

  var TZ = "Europe/Berlin";
  function berlinParts(seconds) {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: TZ,
      hourCycle: "h23",
      weekday: "short",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
      .formatToParts(new Date(seconds * 1000))
      .reduce(function (a, p) {
        a[p.type] = p.value;
        return a;
      }, {});
  }
  var WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // "Bis So., 11.10., 23:59 Uhr" from data-template ([weekday] [date] [time]), the locale's weekdays_short list and
  // until_date_format (strftime subset %d %m %Y %y).
  function untilText(el, end) {
    var p = berlinParts(end);
    var names = (el.getAttribute("data-weekdays") || "").split(",");
    var weekday = (names[WEEKDAYS.indexOf(p.weekday)] || "").trim();
    var date = (el.getAttribute("data-date-format") || "%d.%m.")
      .replace("%d", p.day)
      .replace("%m", p.month)
      .replace("%Y", p.year)
      .replace("%y", p.year.slice(-2));
    return el
      .getAttribute("data-template")
      .replace("[weekday]", weekday)
      .replace("[date]", date)
      .replace("[time]", p.hour + ":" + p.minute);
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll("[data-st-coupon-until]").forEach(function (el) {
      var end = shownEnd(el);
      if (!end || !el.getAttribute("data-template")) return;
      if (el.getAttribute("data-end") === String(end)) return;
      el.setAttribute("data-end", end);
      el.textContent = untilText(el, end);
    });
    document
      .querySelectorAll("[data-st-coupon-countdown]")
      .forEach(function (el) {
        var end = shownEnd(el);
        var format = el.getAttribute("data-format");
        if (!end || !format) return;
        var mins = Math.max(0, Math.floor((end - now) / 60));
        var f = el.getAttribute("data-pad") === "false" ? String : pad;
        var text = format
          .replace("[d]", f(Math.floor(mins / 1440)))
          .replace("[h]", f(Math.floor((mins % 1440) / 60)))
          .replace("[m]", f(mins % 60));
        if (el.textContent !== text) el.textContent = text;
      });
    document.querySelectorAll("[data-st-coupon-end]").forEach(function (el) {
      var end = parseInt(el.getAttribute("data-st-coupon-end"), 10);
      if (end && end <= now && !el.hidden) el.hidden = true;
    });
  }

  function legacyCopy(text) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    var ok;
    try {
      ok = document.execCommand("copy");
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }

  // Wrike 4585808874 (D2 + C + E): the icon buttons (snippets/st-code-button.liquid) have no text label. Feedback:
  // copy icon -> check for 2 s, toast "<code> kopiert / Code an der Kasse eingeben" (or "Code <code>" when copying
  // failed, so it can be typed), screen reader status "Code <code> kopiert"; a new tap restarts the 2 s.
  var toastTimer;
  function escapeHTML(text) {
    return String(text).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function showToast(code, ok) {
    var toast = document.querySelector("[data-st-code-toast]");
    if (!toast) return;
    if (toast.parentNode !== document.body) document.body.appendChild(toast);
    var title = toast.querySelector("[data-st-code-toast-title]");
    var template = toast.getAttribute(ok ? "data-copied" : "data-manual") || "";
    if (title) title.innerHTML = template.replace("[code]", escapeHTML(code));
    toast.classList.toggle("is-manual", !ok);
    toast.classList.add("is-on");
    var status = document.querySelector("[data-st-code-status]");
    if (status && ok) {
      status.textContent = "";
      status.textContent = (toast.getAttribute("data-status") || "").replace(
        "[code]",
        code,
      );
    }
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove("is-on");
      if (status) status.textContent = "";
    }, 2000);
  }
  function iconFeedback(button, code, ok) {
    if (ok) {
      button.classList.add("is-copied");
      clearTimeout(button.__stTimer);
      button.__stTimer = setTimeout(function () {
        button.classList.remove("is-copied");
      }, 2000);
    }
    showToast(code, ok);
    if (ok && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "st_code_copy",
        code: code,
        placement: button.getAttribute("data-st-code-placement") || "",
      });
    }
  }

  function copied(button) {
    var label = button.querySelector("[data-st-coupon-copy-label]");
    if (!label && button.hasAttribute("data-st-code-placement")) {
      iconFeedback(button, button.getAttribute("data-st-coupon-copy"), true);
      return;
    }
    var status =
      button.parentNode &&
      button.parentNode.querySelector("[data-st-coupon-copy-status]");
    if (!label) return;
    if (!button.__stLabel) button.__stLabel = label.textContent;
    label.textContent = button.getAttribute("data-copied-label");
    if (status) status.textContent = button.getAttribute("data-copied-label");
    clearTimeout(button.__stTimer);
    button.__stTimer = setTimeout(function () {
      label.textContent = button.__stLabel;
      if (status) status.textContent = "";
    }, 2000);
  }

  document.addEventListener("click", function (event) {
    var button =
      event.target.closest && event.target.closest("[data-st-coupon-copy]");
    // Wrike 4585808874 round 2: a tap anywhere on the price box code box (C) copies through its button.
    var box =
      !button &&
      event.target.closest &&
      event.target.closest("[data-st-code-box]");
    if (box) button = box.querySelector("[data-st-coupon-copy]");
    if (!button) return;
    event.preventDefault();
    var code = button.getAttribute("data-st-coupon-copy");
    var failed = function () {
      if (button.hasAttribute("data-st-code-placement"))
        iconFeedback(button, code, false);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () {
          copied(button);
        },
        function () {
          if (legacyCopy(code)) copied(button);
          else failed();
        },
      );
    } else if (legacyCopy(code)) {
      copied(button);
    } else {
      failed();
    }
  });

  // Wrike 4585808874: "Endet in hh:mm:ss" in the 44 px top bar and the sticky footer ([data-st-code-countdown]),
  // "1 T · hh:mm:ss" from one day. The footer counts to its data-end (the variant's coupon end, unix s); the top bar
  // to the end of the countdown above it (data-expires: the variant's coupon end, else the next "Enddaten" end).
  // One tick on the full second for both and the tiles above, so all show the same second.
  function headerTimer() {
    return document.querySelector("countdown-timer[data-st-variant-end]");
  }
  function codeTick() {
    var now = Date.now();
    var timer = headerTimer();
    if (timer && timer.initialized && typeof timer.calculate === "function")
      timer.calculate();
    document
      .querySelectorAll("[data-st-code-countdown]")
      .forEach(function (el) {
        var end = (parseInt(el.getAttribute("data-end"), 10) || 0) * 1000;
        if (!end && timer)
          end = Date.parse(timer.getAttribute("data-expires")) || 0;
        var left = Math.max(0, Math.floor((end - now) / 1000));
        var days = Math.floor(left / 86400);
        var text =
          pad(Math.floor((left % 86400) / 3600)) +
          ":" +
          pad(Math.floor((left % 3600) / 60)) +
          ":" +
          pad(left % 60);
        if (days > 0)
          text =
            days + " " + (el.getAttribute("data-day") || "") + " · " + text;
        if (el.textContent !== text) el.textContent = text;
      });
    // Wrike 4580939861 round 18 (QA 22.10.): the footer line (chip · code · "Endet in" time) is a few px wider than
    // 375-390 px phones and cut the time ("02:37:0"). Like the top bar (is-tighter), drop the "Endet in" label then.
    // Measured only when the line width, the time's length ("1 T ·", variant change) or the font state changes.
    document
      .querySelectorAll(".st-colbar__row1[data-st-strip-bar]")
      .forEach(function (row) {
        var ends = row.querySelector(".st-colbar__ends");
        var time = row.querySelector(".st-colbar__ends-time");
        if (!ends || !time || !row.clientWidth) return;
        var key =
          row.clientWidth +
          ":" +
          time.textContent.length +
          ":" +
          (document.fonts ? document.fonts.status : "");
        if (row.__stFitKey === key) return;
        ends.classList.remove("is-tight");
        if (row.scrollWidth > row.clientWidth + 1)
          ends.classList.add("is-tight");
        row.__stFitKey = key;
      });
    // round 2: footer E shows only after the main button; re-check when the code ends or the variant changes
    document.querySelectorAll(".st-colbar").forEach(function (bar) {
      if (typeof bar.applyBar === "function") bar.applyBar();
    });
  }
  codeTick();
  setTimeout(
    function () {
      codeTick();
      setInterval(codeTick, 1000);
    },
    1000 - (Date.now() % 1000) + 20,
  );

  // Wrike 4585808874 (D2, 1b): the 44 px top bar is on while the selected variant has an active code (box C /
  // footer E present and not ended) and the campaign section shows. Round 2 (Argus for Ali 18.10.): from the top of
  // the page, not only after scrolling. Round 5 (Argus for Ali 18.10.): not sticky; the bar sits in the section in
  // place of the two-line bar (.st-cdh--bar hides that one) and scrolls away like live.
  function bindCodebar() {
    var bar = document.querySelector("[data-st-codebar]");
    if (!bar) return;
    var section = document.getElementById(bar.getAttribute("data-section"));
    if (!section) return;
    var inner = section.querySelector(".st-countdown-header");
    var phone = window.matchMedia("(max-width: 767px)");
    function codeActive() {
      var marks = document.querySelectorAll("[data-st-code-active]");
      if (!marks.length) return true;
      return Array.prototype.some.call(marks, function (el) {
        return !el.hidden;
      });
    }
    function apply() {
      var on =
        phone.matches &&
        !section.hidden &&
        section.style.display !== "none" &&
        codeActive();
      bar.classList.toggle("is-on", on);
      if (inner) inner.classList.toggle("st-cdh--bar", on);
      if (on) fit();
    }
    // Round 6 (Argus for Ali 18.10.): one line without overlap in every market from 320 px. If the code button is
    // wider than its place, drop the words before the code ("CON EL CÓDIGO" …), then the "Endet in" label. Measured
    // only when the bar width or the countdown width changes (fonts, rotation, "1 T ·" appearing).
    var btn = bar.querySelector(".st-codebar__btn");
    var ends = bar.querySelector(".st-codebar__ends");
    var fitKey = "";
    function overflows() {
      return btn.scrollWidth > btn.clientWidth + 1;
    }
    function fit(force) {
      if (!btn || !ends) return;
      var key = bar.clientWidth + ":" + ends.offsetWidth;
      if (!force && key === fitKey) return;
      bar.classList.remove("is-tight", "is-tighter");
      if (overflows()) bar.classList.add("is-tight");
      if (overflows()) bar.classList.add("is-tighter");
      fitKey = bar.clientWidth + ":" + ends.offsetWidth;
    }
    apply();
    bar.stApply = apply;
    if (phone.addEventListener) phone.addEventListener("change", apply);
    if (document.fonts && document.fonts.ready)
      document.fonts.ready.then(function () {
        fit(true);
      });
    setInterval(apply, 1000);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindCodebar, { once: true });
  } else {
    bindCodebar();
  }

  var tries = 0;
  function bindVariant() {
    if (!(window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS)) {
      if (++tries > 25) return;
      return setTimeout(bindVariant, 200);
    }
    theme.pubsub.subscribe(
      theme.pubsub.PUB_SUB_EVENTS.variantChange,
      function (payload) {
        // publish() has no try/catch: a throw here would break the other handlers.
        try {
          var d = payload && payload.data;
          if (!d || !d.parsedHTML) return;
          var id = "CouponBox-" + d.sectionId + "-" + d.productId;
          var src = d.parsedHTML.querySelector("#" + id);
          var dst = document.getElementById(id);
          if (src && dst && dst.innerHTML !== src.innerHTML)
            dst.innerHTML = src.innerHTML;
          // Wrike 4585808874 (C): code row of the price box for the new variant (or its empty placeholder).
          var dealId =
            "StCodeDeal-ProductForm-" + d.sectionId + "-" + d.productId;
          var dealSrc = d.parsedHTML.querySelector("#" + dealId);
          var dealDst = document.getElementById(dealId);
          if (dealSrc && dealDst && dealDst.outerHTML !== dealSrc.outerHTML)
            dealDst.replaceWith(document.importNode(dealSrc, true));
          var codebar = document.querySelector("[data-st-codebar]");
          if (codebar && codebar.stApply) codebar.stApply();
          // Wrike 4582273667 (Ali 14.10.): the top bar counts to the new variant's coupon end; no coupon -> global
          // end. Only for the page's main product (its box exists here).
          var bar =
            dst &&
            document.querySelector("countdown-timer[data-st-variant-end]");
          if (bar && src) {
            var box = src.querySelector("[data-st-coupon-end]");
            var end = (box && box.getAttribute("data-st-coupon-end")) || "";
            if (bar.getAttribute("data-st-variant-end") !== end) {
              bar.setAttribute("data-st-variant-end", end);
              if (typeof bar.stUpdateEnd === "function") bar.stUpdateEnd();
            }
          }
          tick();
        } catch (e) {
          /* ignore */
        }
      },
    );
  }

  tick();
  setInterval(tick, 1000);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindVariant, { once: true });
  } else {
    bindVariant();
  }
})();
